import { FlaskConical } from 'lucide-react'

/*
  Rendered when a payload comes back with `demo: true`, so sample numbers are
  never mistaken for live ones. Sales::Report answers `false`, so this stays
  hidden unless something starts serving fixtures again.
*/
export default function DemoBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-line bg-surface px-2.5 py-1 text-xs text-ink-2">
      <FlaskConical className="size-3 text-warning" aria-hidden="true" />
      Sample data
    </span>
  )
}
